/*jshint esversion: 11 */
import sendApiRequest from '../helpers/axios-image-setup';

/**
 *
 * @returns {Promise}
 */
export async function fetchImage(key) {
  try {
    const response = await sendApiRequest.get(`/file/${key}/new`);
    return response.data.signedUrl;
  } catch (e) {
    return null;
  }
}

/**
 *
 * @returns {Promise}
 */
export async function fetchImageAsBlob(key) {
  try {
    const response = await sendApiRequest.get(`/file/${key}`, {
      responseType: 'blob'
    });
    return URL.createObjectURL(response.data);
  } catch (e) {
    return null;
  }
}
